// the sub header will take in molecules/search.js and atoms/button.js
import React from 'react';
import { useContext } from 'react';
import { DNCContext } from '../../context';
import { useState } from 'react';
import { Button, Container, FormControl } from 'react-bootstrap';
import { useEffect } from 'react';
import ExportCSV from './ExportCSV';

function SubHeader() {
    const { dncData, setFilteredData, setActiveIndex, setOffset } = useContext(DNCContext);
    const [keyword, setKeyword] = useState('');

    const SEARCH_FIELDS = ['first_name', 'last_name', 'address1', 'primary_email', 'organization', 'city', 'state', 'zip', 'home_phone', 'mobile_phone', 'work_phone'];

    const handleSearchKeyword = () => {
      const trimmed = keyword.trim();
      if(trimmed) {
        // Split "john doe" into ["john", "doe"] and require every word to
        // match *some* field, rather than requiring the whole phrase to
        // appear in a single field. Previously "john doe" matched nothing
        // because first_name only contains "john" and last_name only "doe" -
        // neither field contains the full phrase.
        const words = trimmed.split(/\s+/).filter(Boolean);
        setFilteredData(dncData.filter(d =>
          words.every(word =>
            SEARCH_FIELDS.some(field => d[field] && d[field].toLowerCase().includes(word))
          )
        ));
      } else {
        setFilteredData(dncData);
      }
      //reset pagination activeIndex
      setActiveIndex(0);
      setOffset(0);
    }

    useEffect(() => {
      handleSearchKeyword()
    }, [keyword])
    return(
        <div className="search-header mb-3">
          <Container className='d-flex flex-column flex-md-row gap-3 justify-content-between'>
              <div className='d-flex gap-2 order-2'>
                <Button variant="light" className="mr-4 custom-btn" href="/import-csv">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                  <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                </svg>  <span style={{marginLeft: 5  }}>Import</span>
                </Button>
                <ExportCSV />
              </div>
              <div className='d-flex order-1 order-md-3'>
            
                <FormControl 
                  onChange={(e) => setKeyword(e.target.value.toLowerCase())}
                  type="text"
                  id="searchInput"
                  className="mr-4 custom-input"
                  placeholder="Search name, email etc..."
                  style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
                  />
                <a 
                  className='button'
                  href='/add-contact'
                  style={{ borderTopRightRadius: '0.375rem', borderBottomRightRadius: '0.375rem'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                </svg> Add new
                </a>   
              </div>
          </Container>
        </div>
    );
}

export default SubHeader;